<template>
  <div class="container">
    <div
      v-check-visible-viewport="onVisibleInViewport"
      class="podcast-trailer-list"
    >
      <el-row
        v-if="bucket.name"
        type="flex"
        justify="space-between"
        align="start"
        class="list-header">
        <h4 class="heading">{{ bucket.name }} </h4>
      </el-row>
      <flickity
        ref="flickity"
        :key="bucketItems.length"
        :options="flickityOptions">
        <div
          v-for="(item,index) in bucketItems"
          :key="index"
          :data-segment-uuid="item.uuid"
          class="podcast-list-container">
          <podcast-trailer
            :trailer="item"
            :bucket="bucketData"
            :key="index"
            @play="onPlay"
            @showPremiumModal="show_premium_modal = true"/>
        </div>
      </flickity>
    </div>
    <premium-modal
      v-if="show_premium_modal"
      :show_modal="show_premium_modal"
      @modalClosed="show_premium_modal = false"/>
  </div>
</template>
<script>
import * as log from 'loglevel';
import Flickity from 'vue-flickity';
import PodcastTrailer from './PodcastTrailer';
import PremiumContentModal from './PremiumContentModal';
import CarouselMixin from '../shared/carouselMixin';

export default {
  components: {
    'podcast-trailer': PodcastTrailer,
    'premium-modal': PremiumContentModal,
    Flickity,
  },
  mixins: [CarouselMixin],
  props: {
    heading: {
      type: String,
      default: '',
    },
    bucket: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      flickityOptions: {
        prevNextButtons: true,
        freeScroll: true,
        pageDots: false,
        wrapAround: false,
        cellAlign: 'left',
        initialIndex: 0,
        contain: true,
        draggable: '>1',
        groupCells: true,
      },
      clickable: true,
      show_premium_modal: false,
      scrollCount: 1,
      itemsShown: 0,
      scroll_sensitivity: 500, // more means less sensitive
    };
  },
  watch: {
    bucketItems() {
      if (this.bucketItems.length) {
        this.reloadCells();
      }
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.removeResizeEvent();
  },
  methods: {
    init() {
      if (this.bucket.items && this.bucket.items.length) {
        this.bucketItems = this.bucket.items;
        this.bucketData = { ...this.bucket };
        this.bucketData.items = [];
        this.bucketData.position = this.$vnode.key;
        this.bucketData.media_size = 'trailer';
        this.bucketData.items_count = this.bucket.items.length;

        this.dragStart();
        this.carouselSettled();
        this.arrowVisibility();
      }
    },
    reloadCells() {
      this.$refs.flickity.reloadCells();
      this.$forceUpdate();
    },
    bindMouseWheelEvent() {
      if (this.$refs.flickity) {
        this.$refs.flickity.$el.addEventListener('wheel', this.mouseScroll);
      } else {
        log.info('Flickity Not Yet Rendered');
      }
    },
    removeMouseWheelEvent() {
      if (this.$refs.flickity) {
        this.$refs.flickity.$el.removeEventListener('wheel', this.mouseScroll);
      } else {
        log.info('Flickity event does not exists');
      }
    },
    onPlay() {
      this.$emit('play', this.bucket.uuid);
    },
    dragStart() {
      this.$nextTick()
        .then(() => {
          this.$refs.flickity.on('dragStart', () => {
            this.clickable = false;
          });
        })
        .catch((err) => { log.warn(err.message); });
    },
    carouselSettled() {
      this.$nextTick()
        .then(() => {
          this.$refs.flickity.on('settle', (currIndex) => {
            this.clickable = true;
            this.scrollCount = currIndex + 1;
            this.triggerSegmentContentViewedEvent();
          });
        })
        .catch((err) => { log.warn(err.message); });
    },
    arrowVisibility() {
      this.checkWindowSizes();
      window.addEventListener('resize', this.checkWindowSizes);
    },
    removeResizeEvent() {
      window.removeEventListener('resize', this.checkWindowSizes);
    },
    checkWindowSizes() {
      if (!this.$refs.flickity) return;
      this.$nextTick().then(() => {
        const pl = this.$el.querySelector('.podcast-trailer-list');
        const pc = this.$el.querySelector('.podcast-trailer');
        if (!pl || !pc) return;

        const a = pl.clientWidth;
        const b = pc.clientWidth;
        const c = Math.floor(a / b);
        this.itemsShown = c;
        if (this.bucketItems.length <= c) {
          this.hideArrows();
          this.removeMouseWheelEvent();
        } else {
          this.showArrows();
          this.bindMouseWheelEvent();
        }
      });
    },
    hideArrows() {
      const a = this.$el.querySelector('.flickity-button.next');
      const b = this.$el.querySelector('.flickity-button.previous');
      if (a) this.$el.querySelector('.flickity-button.next').className += ' d-none';
      if (b) this.$el.querySelector('.flickity-button.previous').className += ' d-none';
    },
    showArrows() {
      const elem = this.$el.querySelectorAll('.flickity-button.next,.flickity-button.previous');
      if (!elem[0] || !elem[1]) return;
      if (elem[0].classList.contains('d-none')) {
        this.$el.querySelector('.flickity-button.next').classList.remove('d-none');
      }
      if (elem[1].classList.contains('d-none')) {
        this.$el.querySelector('.flickity-button.previous').classList.remove('d-none');
      }
    },
    mouseScroll(e) {
      if (Math.abs(e.wheelDeltaY)) {
        e.stopPropagation();
        return;
      }
      if (e.wheelDeltaX > 0) {
        const selectedCell = (this.itemsShown * (this.scrollCount - 1)) - 1;
        this.$refs.flickity.selectCell(selectedCell);
      } else {
        const selectedCell = (this.itemsShown * this.scrollCount) + 1;
        this.$refs.flickity.selectCell(selectedCell);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
.podcast-trailer-list {
  .list-header {
    margin-bottom: 16px;
    h4 {
      margin: 0 0 !important;
    }
  }
}
@media (max-width: $xs) {
  .podcast-trailer-list {
    .list-header {
      margin-top: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PodcastTrailerList.vue